import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard, scheduleManagerGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
    title: 'Login | Workforce Madero',
  },
  {
    path: 'login',
    redirectTo: '',
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
    canActivate: [authGuard],
    title: 'Dashboard Executivo | Workforce Madero',
  },
  {
    path: 'schedule-planning',
    loadComponent: () =>
      import('./pages/schedule-planning/schedule-planning.component').then(
        (m) => m.SchedulePlanningComponent
      ),
    canActivate: [authGuard, scheduleManagerGuard],
    title: 'Planejamento Manual de Escalas | Workforce Madero',
  },
  {
    path: 'planejamento',
    redirectTo: 'schedule-planning',
  },
  {
    path: 'auto-schedule',
    redirectTo: 'schedule-planning',
  },
  {
    path: 'escala-automatica',
    redirectTo: 'schedule-planning',
  },
  {
    path: 'branches',
    loadComponent: () =>
      import('./pages/branches/branches.component').then((m) => m.BranchesComponent),
    canActivate: [authGuard, adminGuard],
    title: 'Operações & Regras de Escala | Workforce Madero',
  },
  {
    path: 'operacoes',
    redirectTo: 'branches',
  },
  {
    path: 'employees',
    loadComponent: () =>
      import('./pages/employees/employees.component').then((m) => m.EmployeesComponent),
    canActivate: [authGuard],
    title: 'Funcionários, Jornadas & Férias | Workforce Madero',
  },
  {
    path: 'funcionarios',
    redirectTo: 'employees',
  },
  {
    path: 'demand-history',
    loadComponent: () =>
      import('./pages/demand-history/demand-history.component').then((m) => m.DemandHistoryComponent),
    canActivate: [authGuard, adminGuard],
    title: 'Histórico de Pedidos & Feriados | Workforce Madero',
  },
  {
    path: 'demanda',
    redirectTo: 'demand-history',
  },
  {
    path: 'timecard',
    loadComponent: () =>
      import('./pages/timecard/timecard.component').then((m) => m.TimecardComponent),
    canActivate: [authGuard],
    title: 'Aderência Escala x Ponto | Workforce Madero',
  },
  {
    path: 'ponto',
    redirectTo: 'timecard',
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./pages/reports/reports.component').then((m) => m.ReportsComponent),
    canActivate: [authGuard, adminGuard],
    title: 'Central de Relatórios | Workforce Madero',
  },
  {
    path: 'relatorios',
    redirectTo: 'reports',
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin/admin.component').then((m) => m.AdminComponent),
    canActivate: [authGuard, adminGuard],
    title: 'Administração & Auditoria | Workforce Madero',
  },
  {
    path: '**',
    redirectTo: '',
  },
];
